"use client";

import { useLocale } from "next-intl";

export function useTranslation(namespace: string) {
  const formatLocale = useLocale();
  void namespace;

  return {
    formatLocale,
    timeZone: null,
  };
}
